export const LANGUAGE_STORAGE_KEY = 'ce-language'

export const PRODUCTION_LANGUAGES = ['en', 'hu']

export const PSEUDO_LANGUAGE = 'pseudo'

export const FALLBACK_LANGUAGE = 'en'

export const isPseudoLanguageEnabled = () => process.env.NODE_ENV !== 'production'

export const getSupportedLanguages = () => (isPseudoLanguageEnabled() ? [...PRODUCTION_LANGUAGES, PSEUDO_LANGUAGE] : PRODUCTION_LANGUAGES)

// Maps en-AU / hu-HU / hu_HU onto the language-only codes the catalogs use.
export const normalizeLanguage = (value) => {
  if (!value || typeof value !== 'string') return null

  const language = value.toLowerCase().split(/[-_]/)[0]

  if (PRODUCTION_LANGUAGES.includes(language)) return language
  if (language === PSEUDO_LANGUAGE && isPseudoLanguageEnabled()) return PSEUDO_LANGUAGE

  return null
}

const getStorage = (storage) => {
  if (storage) return storage

  try {
    return typeof window !== 'undefined' ? window.localStorage : null
  } catch {
    return null
  }
}

export const getStoredLanguage = (storage) => {
  try {
    return normalizeLanguage(getStorage(storage)?.getItem(LANGUAGE_STORAGE_KEY))
  } catch {
    return null
  }
}

export const setStoredLanguage = (language, storage) => {
  const normalized = normalizeLanguage(language)
  if (!normalized) return null

  try {
    getStorage(storage)?.setItem(LANGUAGE_STORAGE_KEY, normalized)
  } catch {
    // Storage can be unavailable (private mode); the in-memory language still changes.
  }

  return normalized
}

export const clearStoredLanguage = (storage) => {
  try {
    getStorage(storage)?.removeItem(LANGUAGE_STORAGE_KEY)
  } catch {
    // Storage can be unavailable (private mode); the market default still applies in memory.
  }
}

export const getBrowserLanguage = (languages) => {
  const navigatorLanguages =
    typeof navigator !== 'undefined' ? (navigator.languages?.length ? navigator.languages : [navigator.language]) : []
  const candidates = languages || navigatorLanguages

  for (const candidate of candidates) {
    const normalized = normalizeLanguage(candidate)
    if (normalized) return normalized
  }

  return null
}

// persisted user override -> market default -> browser language (before the market is known)
export const resolveLanguage = ({ browserLanguage, marketLanguage, storedLanguage } = {}) =>
  normalizeLanguage(storedLanguage) || normalizeLanguage(marketLanguage) || normalizeLanguage(browserLanguage) || FALLBACK_LANGUAGE
